<template>
  <div class="osk-wrapper vertical-paddings">
    <h2 class="section-title text-center">
      {{ $t('components.info.kontaktyPage.title') }}
    </h2>

    <div class="info-wrapper">
      <div class="info-block">
        <p>{{ $t('components.info.kontaktyPage.text') }}</p>

        <ul>
          <li>
            <span>{{ $t('components.info.kontaktyPage.phone') }}</span>

            <a :href="`tel:${contacts.telephoneRaw}`">{{ contacts.telephonePrettyPrinted }}</a>
          </li>

          <li>
            <span>{{ $t('components.info.kontaktyPage.email') }}</span>

            <a :href="`mailto:${contacts.email}`">{{ contacts.email }}</a>
          </li>

          <li>
            <span>{{ $t('components.info.kontaktyPage.social') }}</span>

            <ul>
              <li>
                <a :href="socials.vk">
                  <UikitIcon
                    name="VkIcon"
                    size="l"
                    color="black"
                  />
                </a>
              </li>

              <li>
                <a :href="socials.youtube">
                  <UikitIcon
                    name="Youtube"
                    size="l"
                    color="black"
                  />
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Контакты – Интернет-магазин Oskelly',
  meta: [
    {
      name: 'description',
      content: 'Контакты – Интернет-магазин Oskelly',
    },
  ],
});

const {
  contacts,
  socials,
} = useCompanyInfo();
</script>

<style lang="scss" scoped>
.vertical-paddings {
  padding-top: 70px;
  padding-bottom: 100px;
}

.info-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 76px;
}

.info-wrapper .info-block {
  max-width: 430px;
}

.info-wrapper .info-block p {
  font-size: 18px;
  line-height: 24px;
  margin-top: 5px;
  letter-spacing: -1.1px;
}

.info-wrapper .info-block > ul {
  margin-top: 37px;
}

.info-wrapper .info-block > ul > li {
  margin-bottom: 33px;
}

.info-wrapper .info-block > ul > li span {
  font-size: 13px;
  letter-spacing: .5px;
  color: #828282;
  font-weight: 500;
  text-transform: uppercase;
  display: block;
  margin-bottom: 10px;
}

.info-wrapper .info-block > ul > li > a {
  font-size: 25px;
  font-weight: 700;
}

.info-wrapper .info-block > ul > li ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 13px;
}
.info-wrapper .info-block > ul > li ul li {
  margin-right: 19px;
}

.info-wrapper .info-block > ul > li ul li:last-child {
  margin-right: 0;
}
</style>
